import { useEffect, useState } from "react";
import { User } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

const MS_TOKEN_KEY = "ms_provider_token";
const MS_REFRESH_TOKEN_KEY = "ms_provider_refresh_token";

// Sessão já resolvida por outra instância (undefined = ainda não). RequireAuth e
// DashboardLayout remontam a cada página; sem isso cada clique no menu passava
// por um spinner de tela cheia que tirava o menu do lugar (retorno 20/10/2026).
let knownUser: User | null | undefined;

export function useAuth() {
  const [user, setUser] = useState<User | null>(knownUser ?? null);
  const [loading, setLoading] = useState(knownUser === undefined);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        knownUser = session?.user ?? null;
        setUser(knownUser);
        setLoading(false);

        // Capture Microsoft provider tokens on sign-in
        if (event === "SIGNED_IN" && session) {
          if (session.provider_token) {
            localStorage.setItem(MS_TOKEN_KEY, session.provider_token);
          }
          if (session.provider_refresh_token) {
            localStorage.setItem(MS_REFRESH_TOKEN_KEY, session.provider_refresh_token);
          }
        }

        if (event === "SIGNED_OUT") {
          localStorage.removeItem(MS_TOKEN_KEY);
          localStorage.removeItem(MS_REFRESH_TOKEN_KEY);
        }
      }
    );

    supabase.auth.getSession().then(({ data: { session } }) => {
      knownUser = session?.user ?? null;
      setUser(knownUser);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  return { user, loading };
}

export function getMsProviderToken(): string | null {
  return localStorage.getItem(MS_TOKEN_KEY);
}

export function getMsProviderRefreshToken(): string | null {
  return localStorage.getItem(MS_REFRESH_TOKEN_KEY);
}

export function setMsProviderToken(token: string) {
  localStorage.setItem(MS_TOKEN_KEY, token);
}
